import React from 'react'
import {Form, Icon, Input, Checkbox, Radio, Select} from 'antd';

import PatientElectronicText from './Texts/PatientElectronicText';
import SurrogateElectronicText from './Texts/SurrogateElectronicText';
import Signature from "./Signature";

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;

    const showForEmail = !(props.consentMethodType === 'Email' && !props.token);

    return (
      <div className="form-group">
        <h4>{props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'}</h4>

        <div className="form-group-details">
          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.consentPersonType === 'Surrogate' ? <SurrogateElectronicText {...props} /> :
          <PatientElectronicText {...props} />}

        <p><strong>Server Date (UTC): {props.date || props.consentDate}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <h4>DOCUMENTATION OF INFORMED CONSENT</h4>

        <div style={{ textAlign: 'left' }}>

          {showForEmail && <div>
            <Form.Item>
              <label>
                <div className='form-label'>Please check the appropriate box to indicate your decision:</div>
                {props.form.getFieldDecorator('kw_consent_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='stay_in_study'>
                      I wish to stay in the study.
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      I wish to withdraw from the study
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study_allow_data_collection_via_linkage'>
                      I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
          </div>}
          <br/><br/>


          <Form.Item>
            <label>
              <div className='form-label'>Participant's Name</div>
              {props.form.getFieldDecorator('kw_consent_participant_name', {
                initialValue: props.kw_consent_participant_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Participant's Name"
                />
              )}
            </label>
          </Form.Item>

          {props.consentMethodType === 'Email' && <Form.Item>
            {props.form.getFieldDecorator('kw_participant_email', {
              initialValue: props.kw_participant_email,
              rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="Participant Email"/>
            )}
          </Form.Item>}

          <h4>SIGNATURES</h4>
          {showForEmail && <div>
            <p>Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a participant. In no way does this waive your legal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:</p>

            <p>
              Dr. Aleksander Tkach 250-800-1196 or
              <br/>
              Clinical Research Department 778-214-2065
            </p>

            <p>If you have any questions concerning your rights as a possible participant in this research, please contact the Interior Health Research Ethics Board Chair by calling 250-870-4602 or email researchethics@interiorhealth.ca.</p>

          </div>}

          {props.consentPersonType === 'Patient' && showForEmail  && (
            <div>
              <Signature fieldName='kw_consent_participant_signature' label='Signature of Participant' form={props.form} />
            </div>
          )}

          {props.consentPersonType === 'Surrogate' && showForEmail && <div>
            <Form.Item>
              <label>
                <div className='form-label'>Name of Legally Authorized</div>
                {props.form.getFieldDecorator('kw_representative_name', {
                  initialValue: props.kw_representative_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Name of Legally Authorized"
                  />
                )}
              </label>
            </Form.Item>
            <Form.Item>
              <label>
                <div className='form-label'>Relationship to Participant</div>
                {props.form.getFieldDecorator('kw_representative_relationship_to_participant', {
                  initialValue: props.kw_representative_relationship_to_participant,
                  rules: [{
                    required: !props.token,
                    message: 'Required'
                  }],
                })(
                  <Input
                    placeholder="Relationship to Participant"
                  />
                )}
              </label>
            </Form.Item>

            <Signature fieldName='kw_representative_signature' label='Signature of Legally Authorized' form={props.form} />
          </div>}

          <div>
            <Form.Item>
              <label>
                <div className='form-label'>Investigator/Delegate’s Name</div>
                {props.form.getFieldDecorator('kw_consent_investigator_name', {
                  initialValue: props.kw_consent_investigator_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Investigator/Delegate’s Name"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && <Signature fieldName='kw_consent_investigator_signature' label='Signature of Investigator/Delegate' form={props.form} />}
          </div>


          {showForEmail && <div>
            <Form.Item>
              <label>
                <div className='form-label'>Do you consent to the terms described above?</div>
                {props.form.getFieldDecorator('consent_provided', {
                  initialValue: props.consent_provided,
                  rules: [{
                    required: true,
                    message: 'Do you consent to the terms described above?'
                  }],
                })(
                  <Select>
                    <Option value="yes">Yes</Option>
                    <Option value="">No</Option>
                  </Select>
                )}
              </label>
            </Form.Item>
          </div>}

          <p>The Interior Health Research Ethics Board has approved this research study.  A signed copy of this consent form has been given to you to keep for your records and reference.</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeKelowna/Step3aPatient.js